import { ApplicationError } from './application.error';

export class NetworkError extends ApplicationError {
  constructor(message: string = 'No se pudo conectar con el servidor. Comprueba tu conexión a internet.') {
    super(message, 'NETWORK_ERROR');
  }
}
